import { Header } from "../../components/Header"
import { useParams } from "react-router-dom";
import { FQDN } from "../../components/FQDN";
import { FQDNData, getFQDN } from "../../remote/scan_data";
import { useEffect, useState } from "react";
import { ScanChildren } from "../../components/ScanChildren";
import { Box, CircularProgress, Container } from "@mui/material";

export const TreeFQDN = () => {
	const params = useParams()
	const entityId = params.entityId;

	if ( ! entityId) {
		return <CircularProgress />
	}

	const [fqdnData, setFQDNData] = useState<FQDNData | null>(null);
	useEffect(() => {
		getFQDN(entityId, (data, resp) => {
			if (data) {
				setFQDNData(data);
			} else {
				setFQDNData(null);
			}
		});
	}, [setFQDNData]);

	return (fqdnData ? <>
		<Header />
		<Container>
			<FQDN id={entityId} data={fqdnData} hideChildren/>
			<Box margin={1}></Box>
			<ScanChildren data={fqdnData.children} />
		</Container>
	</> : <CircularProgress />)
}
